/**
 * Blog listing search params. Plain validator (no zod) because validateSearch
 * runs in the critical route bundle that every page downloads.
 */
export type BlogSearch = { page?: number; category?: string };

export function parseBlogSearch(s: Record<string, unknown>): BlogSearch {
  const out: BlogSearch = {};
  if (s.page !== undefined) {
    const n = Number(s.page);
    out.page = Number.isInteger(n) && n >= 1 && n <= 50 ? n : 1;
  }
  if (s.category !== undefined) {
    out.category = typeof s.category === "string" && s.category.length <= 80 ? s.category : "";
  }
  return out;
}
